// extracted by mini-css-extract-plugin
export var active = "NavbarMenu-module--active--60096";
export var container = "NavbarMenu-module--container--43b69";
export var menuItem = "NavbarMenu-module--menuItem--79347";